import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';

initFederation(environment.remoteManifestPath).then(() => import('./bootstrap'));
